const ALL_ITEMS_REMOVED_ANNOUNCER_TEXT_KEY = "allitemsremovedannouncertext";
const COMPARE_BUTTON_TEXT_KEY = "comparebuttontext";
const COMPARE_PRODUCT_TILE_COMPONENT_NAME = "CompareProductTile";
const COMPARE_PRODUCTS_LOCAL_STORAGE_KEY = "compare";
const COMPARE_PRODUCTS_MIN_LOCAL_STORAGE_KEY = "compareMin";
const COMPARE_PRODUCTS_MODULE_SETTINGS_DEVELOPER_KEY = "compare-products";
const COMPONENT_NAME = "CompareProducts";
const EMPTY_SLOT_NUMBER_TEMPLATE = "{slotNumber}";
const EMPTY_SLOT_TEXT_KEY = "emptyslottext";
const ERROR_TEXT_KEY = "errortext";
const HIDE_BUTTON_TEXT_KEY = "hidebuttontext";
const ITEM_REMOVED_ANNOUNCER_TEXT_KEY = "itemremovedannouncertext";
const MAX_PRODUCTS_TO_COMPARE = 4;
const MODAL_TITLE_KEY = "modaltitle";
const POPUP_ARIA_LABEL_KEY = "popuparialabel";
const REGION_UPDATED_ANNOUNCER_TEXT_KEY = "regionupdatedannouncertext";
const REMOVE_BUTTON_TEXT_KEY = "removeallbuttontext";
const REMOVE_LINK_TEXT_KEY = "removelinktext";
const SHOW_BUTTON_TEXT_KEY = "showbuttontext";
export {
  ALL_ITEMS_REMOVED_ANNOUNCER_TEXT_KEY,
  COMPARE_BUTTON_TEXT_KEY,
  COMPARE_PRODUCTS_LOCAL_STORAGE_KEY,
  COMPARE_PRODUCTS_MIN_LOCAL_STORAGE_KEY,
  COMPARE_PRODUCTS_MODULE_SETTINGS_DEVELOPER_KEY,
  COMPARE_PRODUCT_TILE_COMPONENT_NAME,
  COMPONENT_NAME,
  EMPTY_SLOT_NUMBER_TEMPLATE,
  EMPTY_SLOT_TEXT_KEY,
  ERROR_TEXT_KEY,
  HIDE_BUTTON_TEXT_KEY,
  ITEM_REMOVED_ANNOUNCER_TEXT_KEY,
  MAX_PRODUCTS_TO_COMPARE,
  MODAL_TITLE_KEY,
  POPUP_ARIA_LABEL_KEY,
  REGION_UPDATED_ANNOUNCER_TEXT_KEY,
  REMOVE_BUTTON_TEXT_KEY,
  REMOVE_LINK_TEXT_KEY,
  SHOW_BUTTON_TEXT_KEY
};
